import { IApiClient } from "@common/network/interfaces";
import { ApiClient } from "@network/client";
import { getConfig } from "@config/index";
import { IGetRegisteredData, IRegistrationData } from "@common/redux/config/interface";

const ENDPOINTS = {
  subscriptionRegistration: () => `api/platform-service/config/subscriptionRegistration`,
  updatedCollaborativeShareUserList: () => `api/platform-service/config/form/permission`,
};

class ConfigRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }
  public addRegistrationData = async (
    registrationData: IRegistrationData
  ) => {
    const payload = registrationData;
    const result = await this.apiClient.post(
      ENDPOINTS.subscriptionRegistration(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };
  public getSubscriptionBundle = async (actionData: IGetRegisteredData) => {
    const { applicationId = "" } = actionData;  
    const result = await this.apiClient.get(
      ENDPOINTS.subscriptionRegistration(),
      { applicationId },
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public updatedCollaborativeShareUserList = async (collaborationData: any) => {
    const payload = collaborationData;
    const result = await this.apiClient.post(
      ENDPOINTS.updatedCollaborativeShareUserList(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result?.data;  
  };

  public getCollaborativePermissionList = async (collaborationData: any) => {
    const  payload  = collaborationData?.collaborativeUserId;
    if (!payload || payload == "") return;
    const result = await this.apiClient.get(
      ENDPOINTS.updatedCollaborativeShareUserList()+`/user/${payload}`,
      "",
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result?.data;
  };

  public getCollaborativeFormUserList = async (collaborationData: any) => {
    const  payload  = collaborationData?.collaborativeFormId;
    const result = await this.apiClient.get(
      ENDPOINTS.updatedCollaborativeShareUserList()+`/form/${payload}`,
      "",
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result?.data;
  };
}

const ConfigRepo = new ConfigRepository(ApiClient);

export { ConfigRepo };
